import { formatNumber } from '~/cynqueModules/formatNumber'

declare module 'vue' {
  interface ComponentCustomProperties {
    $formatNumber(amount: number | string | null): string
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.$formatNumber = (
    amount: number | string | null
  ) => {
    return formatNumber(amount)
  }
})
